import { render, staticRenderFns } from "./ConsultHistory.vue?vue&type=template&id=bc033a86&scoped=true&"
import script from "./ConsultHistory.vue?vue&type=script&lang=js&"
export * from "./ConsultHistory.vue?vue&type=script&lang=js&"
import style0 from "./ConsultHistory.vue?vue&type=style&index=0&id=bc033a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc033a86",
  null
  
)

export default component.exports